<template>
    <!-- Generate Salesman Ledger Modal -->
    <div
        class="modal fade p-0"
        id="addSalesmanLedger"
        tabindex="-1"
        aria-labelledby="salesmanLedgerLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="d-flex flex-wrap w-100 position-relative event-auto">
                <div class="card shadow-none">
                    <div
                        class="card-header card-header-primary d-flex flex-wrap align-items-center position-relative"
                    >
                        <div class="content-card-left w-100">
                            <h4 class="card-title text-white fs-4">Salesman Ledger</h4>
                            <p class="fw-light text-white mb-0 pt-1">
                                Generate ledger PDF for a date range
                            </p>
                        </div>
                    </div>
                    <div class="card-body">
                        <Form
                            @submit="onSubmit"
                            :validation-schema="schema"
                            class="custom-form mt-2"
                            ref="myForm"
                        >
                            <div class="position-relative form-group">
                                <Field
                                    as="select"
                                    name="salesman_id"
                                    class="form-select custom-select"
                                    @click="selectFocus = true"
                                    v-model="salesman_id"
                                >
                                    <option value="0">Choose Salesman</option>
                                    <option
                                        v-for="salesman in salesmen"
                                        :value="salesman.id"
                                        :key="salesman.id"
                                        >{{
                                            salesman.first_name + ' ' + salesman.last_name
                                        }}</option
                                    >
                                </Field>
                                <label
                                    :class="[
                                        selectFocus ? 'focus' : '',
                                        'position-absolute select-label'
                                    ]"
                                    >Salesman</label
                                >
                                <i class="bi bi-caret-down-fill select-arrow position-absolute"></i>
                                <ErrorMessage
                                    class="invalid-message mb-0 pt-2"
                                    name="salesman_id"
                                />
                            </div>
                            <div class="form-group">
                                <v-date-picker
                                    :popover="{ visibility: 'click' }"
                                    class="custom-calendar left-caret-none"
                                    popover-align="right"
                                    v-model="range"
                                    is-range
                                    :columns="$screens({ default: 2, lg: 2 })"
                                    :masks="{ input: 'DD/MM/YY' }"
                                >
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <div class="d-flex align-items-center">
                                            <div
                                                class="position-relative calendar-input-wrapper clearfix w-100"
                                            >
                                                <i
                                                    class="bi bi-calendar3 position-absolute icon-left-placement icon-without-label"
                                                ></i>
                                                <input
                                                    placeholder="From"
                                                    :value="inputValue.start"
                                                    v-on="inputEvents.start"
                                                    class="border-0 icon-left position-relative float-left w-100"
                                                />
                                            </div>
                                            <span class="d-inline-block mx-3 mx-sm-4">To</span>
                                            <div
                                                class="position-relative calendar-input-wrapper clearfix w-100"
                                            >
                                                <i
                                                    class="bi bi-calendar3 position-absolute icon-left-placement icon-without-label"
                                                ></i>
                                                <input
                                                    placeholder="To"
                                                    :value="inputValue.end"
                                                    v-on="inputEvents.end"
                                                    class="border-0 icon-left position-relative float-left w-100"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </v-date-picker>
                                <ErrorMessage class="invalid-message mb-0 pt-2" name="date_range" />
                            </div>
                            <div
                                class="card-footer custom-pagination d-flex flex-wrap justify-content-between m-0 mb-3 px-4 pb-0 border-0 bg-transparent"
                            >
                                <button class="btn btn-primary w-100">
                                    Generate
                                </button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <salesman-ledger-pdf
        :salesman_id="salesmanIdForPdf"
        :count_number="count_number"
        :start_date="range.start"
        :end_date="range.end"
    ></salesman-ledger-pdf>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import salesmanServices from '@/services/SalesmanServices';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';
import SalesmanLedgerPdf from '@/components/pdf/SalesmanLedgerPdf.vue';

export default {
    components: {
        Form,
        Field,
        ErrorMessage,
        SalesmanLedgerPdf,
    },
    setup() {
        const selectFocus = ref(false);
        const salesmen = ref([]);
        const salesman_id = ref(0);
        const count_number = ref(0);
        const range = ref({
            start: '',
            end: '',
        });

        const schema = yup.object().shape({
            salesman_id: yup.number().moreThan(0, 'Salesman Required'),
        });

        onMounted(async () => {
            await salesmanServices.paginateSalesman().then((response) => {
                salesmen.value = response.data.data;
            });
        });

        const salesmanIdForPdf = computed(() => {
            const numeric = Number(salesman_id.value);
            return Number.isNaN(numeric) ? 0 : numeric;
        });

        const onSubmit = async () => {
            if (!range.value.start || !range.value.end) {
                alert('Please select a date range');
                return;
            }
            count_number.value += 1;
        };

        return {
            selectFocus,
            salesmen,
            salesman_id,
            schema,
            onSubmit,
            range,
            count_number,
            salesmanIdForPdf,
        };
    },
};
</script>
